var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{ref:"map",staticStyle:{"height":"600px"}},[_vm._v(" waiting for google map options ")])])}
var staticRenderFns = []

export { render, staticRenderFns }